import * as React from "react";
import { action } from "mobx";
import { observer } from "mobx-react";

import CategoryItemCardContainer, {
    CategoryItemCardContainerProps,
    renderImage,
    renderTextOnlyLine,
} from "../../categoryItemCards/CategoryItemCardContainer";

// Models

// Custom UI

import { CreateListsStore } from "../../../stores/CreateListsStore";
import { Col } from "layout";
import CategoryImage from "models/customLists/CategoryImage";
import OptionsMenu, { MenuOption } from "components/common/OptionsMenu";

const styles = {
    menu: {
        top: 0,
        right: 0,
        position: "absolute",
    } as React.CSSProperties,
};

export interface CategoryImageCardProps extends React.Props<any> {
    store: CreateListsStore;
    image: CategoryImage;
    isSelected: boolean;
}

@observer
export class CategoryImageCard extends React.Component<CategoryImageCardProps> {
    public render() {
        let { image } = this.props;

        let cardProps: CategoryItemCardContainerProps = {};
        cardProps.cardWidth = "100%";
        cardProps.cardHeight = 100;
        cardProps.isSelectable = true;
        cardProps.isSelected = this.props.isSelected;
        cardProps.onCardClicked = this.onCardClicked;

        // let hideOptions =
        //     this.props.store.currentTab === CustomLists.TabSelection.SITE_IMAGES || this.props.store.isSearching;
        return (
            <CategoryItemCardContainer {...cardProps}>
                <Col xs={true}>
                    {image.imageDownloadURL && renderImage(image.imageDownloadURL, 50)}
                    {renderTextOnlyLine(image.title, 14)}
                </Col>
                <div style={styles.menu}>{this.renderMenu()}</div>
            </CategoryItemCardContainer>
        );
    }

    @action
    private onCardClicked = () => {
        if (this.props.isSelected) {
            this.props.store.removeSelectedImage(this.props.image.key);
        } else {
            if (this.props.image.image !== "inProgress") {
                this.props.store.addSelectedImage(this.props.image);
            }
        }
    };

    protected renderMenu() {
        let options: MenuOption[] = [];
        options = [MenuOption.Edit, MenuOption.Move, MenuOption.Delete];

        return <OptionsMenu options={options} onMenuSelectionChangedCallback={this.onMenuSelectionChanged} />;
    }

    private onMenuSelectionChanged = (option: MenuOption) => {
        switch (option) {
            case MenuOption.Edit:
                this.props.store.rootStore.createListsStore.setItemToEdit(this.props.image);
                break;
            case MenuOption.Delete:
                this.props.store.rootStore.createListsStore.deleteCategoryImage(this.props.image);
                break;
            case MenuOption.Move:
                this.props.store.rootStore.createListsStore.setItemToMove(this.props.image);
                break;
            default:
                break;
        }
    };
}
